import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IObjectHaveId {
  id: string
  [key: string]: any
}
interface ISelect {
  listName: string
  selectedItem: IObjectHaveId
}
interface ISelectAll {
  listName: string
  elements: object[]
}

interface IUnSelectAll {
  listName: string
}
interface IInitialState {
  loadingCounter: number
  loading: { [key: string]: boolean }
  lang: string
}
const lang = localStorage.getItem('Lang')
const initialState: IInitialState = {
  loadingCounter: 0,
  loading: {},
  lang: lang || 'ar',
}
export const GlobalSlice = createSlice({
  name: 'Global',
  initialState,
  reducers: {
    setLoadingCounter: (state, action: PayloadAction<number>) => {
      state.loadingCounter += action.payload
    },
    setLoading: (state, action: PayloadAction<{ [key: string]: boolean }>) => {
      state.loading = { ...state.loading, ...action.payload }
    },
    setLang: (state, action: PayloadAction<string>) => {
      localStorage.setItem('Lang', action.payload)
      state.lang = action.payload
    },
  },
})
export const { setLoadingCounter, setLoading, setLang } = GlobalSlice.actions
export default GlobalSlice.reducer
